import styled, { css } from "styled-components";

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;

  @media ${({ theme }) => theme.media.mobile} {
  }

  ${({ $isLarge }) =>
    $isLarge
      ? css`
          gap: 54px;
          min-height: 620px;
          background-color: #ffffff;
          border-radius: 32px;
          padding: 32px;

          @supports (backdrop-filter: blur(63px)) {
            background-color: rgba(255, 255, 255, 0.8);
            backdrop-filter: blur(63.17px);
          }

          @media ${({ theme }) => theme.media.mobile} {
            gap: 30px;
            min-width: 310px;
            max-width: 310px;
            min-height: unset;
            border-radius: 24px;
            padding: 24px;
          }
        `
      : css`
          gap: 30px;
          min-height: 420px;
          background-color: rgba(255, 255, 255, 0.6);
          border-radius: 24px;
          padding: 24px;

          @supports (backdrop-filter: blur(63px)) {
            backdrop-filter: blur(63.17px);
          }

          @media ${({ theme }) => theme.media.mobile} {
            min-width: 290px;
            max-width: 290px;
            min-height: unset;
          }
        `}
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ReviewText = styled.p`
  margin: 0;
  color: rgba(29, 29, 29, 0.85);
  ${({ $isLarge }) =>
    $isLarge
      ? css`
          font-size: 24px;
          font-weight: 500;
          line-height: 1.5;

          @media ${({ theme }) => theme.media.mobile} {
            font-size: 16px;
          }
        `
      : css`
          font-size: 14px;
          font-weight: 400;
          line-height: 1.5;
        `}

  .text-highlight {
    color: #ff6030;
  }
`;

export const Quotes = styled.img.attrs({
  src: "/images/icons/quotes.svg",
  alt: "quotes",
})`
  ${({ $isLarge }) =>
    $isLarge
      ? css`
          width: 30px;
          height: 19.81px;
        `
      : css`
          width: 24px;
          height: 15.85px;
        `}
`;

export const AuthorInfo = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid rgba(29, 29, 29, 0.1);

  ${({ $isLarge }) =>
    $isLarge
      ? css`
          padding-top: 16px;
        `
      : css`
          padding-top: 12px;
        `}
`;

export const AuthorName = styled.div`
  margin: 0;
  color: rgba(29, 29, 29, 0.85);
  line-height: 1.5;
  font-weight: 500;

  ${({ $isLarge }) =>
    $isLarge
      ? css`
          font-size: 20px;

          @media ${({ theme }) => theme.media.mobile} {
            font-size: 16px;
          }
        `
      : css`
          font-size: 16px;
        `}
`;

export const AuthorCEO = styled.div`
  margin: 0;
  color: rgba(29, 29, 29, 0.5);
  line-height: 1.5;
  font-weight: 400;

  ${({ $isLarge }) =>
    $isLarge
      ? css`
          font-size: 16px;

          @media ${({ theme }) => theme.media.mobile} {
            font-size: 14px;
          }
        `
      : css`
          font-size: 14px;
        `}
`;
